import Tabs from "../components/Tabs";
import Overview from "./Overview";
import ServiceCall from "../serviceCall/ServiceCall";
import moment from 'moment';
import React, { Component } from 'react';
import Datum from './Datum'
import Login from '../login/Login'
import Stock from './Stock'
import Config from '../Config'
import VisitHistory from "../serviceCall/VisitHistory";
import Cookies from 'universal-cookie';
import EmergencyCenters from '../components/EmergencyCenters'

class DigibonMain extends Component {
  constructor(props) {
    super(props);


    this.state = {
      mode: "login",
      isActive: false,
      selectedDate: Config.isDev ? new Date() : new Date(),       // for development purposes, you can optionally set to a specific date (new Date(2023,1,12) ), otherwise "today"
      currentBon: null,
      connectionError: false,
      pricelists: null,        // required to be null initially, so that an error can be given when not loaded
      emergencyCenters: null,        // required to be null initially, so that an error can be given when not loaded
      predefinedTexts: [],
      currentTime: moment(),
      showOverview: false,
      selectedUser: null
    };

    this.tabsRef = React.createRef();
  }

  async componentDidMount() {


    // use cookie to retrieve last token
    Config.load().then(p => {
      this.loadCallback();
    }).catch(p => console.log("Error retrieving cookie", p));

    setInterval(() => {
      this.setState({ currentTime: moment() });
    }, 60000);     // refresh each minute

    Config.loadVersion().then(p => {
      this.setState({ version: Config.Version });
    });
  }

  loadCallback() {
    // check to login with cookie
    const cookies = new Cookies();

    //cookies.set('DigibonToken', "expired", { path: "/", expires: new Date(2021,1,1) });

    var token = cookies.get('DigibonToken');
    var jwtToken = cookies.get('DigibonJwtToken');
    if (token && jwtToken) {
      // there is a loging cookie, use it
      this.loginSuccess(token, jwtToken);
    }

  }

  SelectBon(item) {
    // get the products of pricelist of selected bon
    if (!this.state.pricelists) {
      alert("Prijslijsten niet correct geladen, herstart digibon");
      return;
    }
    if (!this.state.emergencyCenters) {
      alert("Alarmcentrales niet correct geladen, herstart digibon");
      return;
    }
    const bpPricelist = item.serviceCall.businessPartner.priceList.id;
    const pricelist = this.state.pricelists.find(p => p.id === bpPricelist);
    if (!pricelist) {
      alert("Ongeldige situatie: prijslijst niet gevonden, herstart digibon");
      return;
    }
    // return only the selectable products  (there are also products needed for descriptions and pricing, such as PA-127, PA-129 etc)
    this.selectableProducts = pricelist.products;

    item.isFirstSave =
      (item.serviceCall.status === 1 || item.serviceCall.status === 3  || item.serviceCall.status === 13) &&      // status must be planned or "tijd nog bevestigen" or "project"
      item.processes === null     // allow changes when there are no existing processes

    this.setState({ mode: "bon", currentBon: item });
  }

  CloseBon() {
    this.setState({ mode: "main", currentBon: null });
  }

  ChangeDate(d) {
    this.setState(
      {
        selectedDate: d
      });
    this.tabsRef.current.selectTab("Overview");
  }

  loginSuccess(token, jwtToken) {
    console.log("LoginSuccess called")
    const cookies = new Cookies();
    let d = new Date();
    d.setTime(d.getTime() + (60 * 60 * 8)); // expire cookie  in 8 hours
    cookies.set('DigibonToken', token, { path: "/", expires: d });
    cookies.set('DigibonJwtToken', jwtToken, { path: "/", expires: d });

    Config.token = token;

    // loading additional data
    this.setState({ mode: "loading", jwtToken: jwtToken, selectedUser: jwtToken.office, selectedDate: new Date(), isTest: Config.isTest });

    // load all pricelists
    this.loadPricelists();
    this.loadEmergencyCenters();
    this.loadDeviceCodeLists();
    this.loadPredefinedTexts();
    Config.loadTechnicians();

  }
  reloginSuccess(token, jwtToken) {
    this.loginSuccess(token, jwtToken);    
  }


  loadPricelists() {
    var url = Config.DigibonServiceBase + "pricelists";
    var options = Config.GetBearer();

    fetch(url, options)
      .then((res) => { return res.ok ? res.json() : { status: res.status } })
      .then((json) => {
        if (json.status === 401) {
          this.tokenExpired(Config.token);
        } else if (json.status) {
          // an error ocurred
          this.setState({ connectionError: true })
        } else {
          this.priceListloadComplete(json);
        }
      }).catch((error) => {
        // reset 
        console.log("loadPriceList load error", error);
        const cookies = new Cookies();
        cookies.remove("DigibonToken");
        cookies.remove("DigibonJwtToken");
        this.setState({ connectionError: true })
      });
  }

  loadEmergencyCenters() {
    var url = Config.DigibonServiceBase + "emergencycenters";
    var options = Config.GetBearer();

    fetch(url, options)
      .then((res) => { return res.ok ? res.json() : { status: res.status } })
      .then((json) => {
        if (json.status === 401) {
          this.tokenExpired(Config.token);
        } else if (json.status) {
          // an error ocurred
          this.setState({ connectionError: true })
        } else {
          this.setState({emergencyCenters: json});
        }
      }).catch((error) => {
        // reset 
        console.log("loadEmergencyCenters load error", error);
        const cookies = new Cookies();
        cookies.remove("DigibonToken");
        cookies.remove("DigibonJwtToken");
        this.setState({ connectionError: true })
      });
  }
  loadDeviceCodeLists() {
    var url = Config.DigibonServiceBase + "devicecodelists";
    var options = Config.GetBearer();

    fetch(url, options)
      .then((res) => { return res.ok ? res.json() : { status: res.status } })
      .then((json) => {
        if (json.status === 401) {
          this.tokenExpired(Config.token);
        } else if (json.status) {
          // an error ocurred
          this.setState({ connectionError: true })
        } else {
          console.log("DeviceCodeLists", json);
          this.setState({deviceCodeLists: json});
        }
      }).catch((error) => {
        // reset 
        console.log("loadDeviceCodeLists load error", error);
        const cookies = new Cookies();
        cookies.remove("DigibonToken");
        cookies.remove("DigibonJwtToken");
        this.setState({ connectionError: true })
      });
  }
  loadPredefinedTexts() {
    var url = Config.DigibonServiceBase + "predefinedtexts";
    var options = Config.GetBearer();
    fetch(url, options)
      .then((res) => { return res.ok ? res.json() : { status: res.status } })
      .then((json) => {

        if (json.status === 401) {
          // ignore
        } else if (json.status) {
          this.setState({ connectionError: true })
        } else {
          this.setState({ predefinedTexts: json });

        }
      }).catch((error) => {
        // not essential, ignore this error
      });
  }

  priceListloadComplete(json) {
    const queryParams = new URLSearchParams(window.location.search)
    if (window.location.pathname === "/test") {
      var options = Config.GetBearer();
      var url = Config.DigibonServiceBase + "testauth";
      fetch(url, options)
        .then((res) => {
          return res.text();
        })
        .then((txt) => {
          this.setState({ mode: "test", testResult: txt });
        });

      return;
    }

    const customer = queryParams.get("customer");
    if (customer === null) {
      // load the main digibon page 
      this.setState({ mode: "main", connectionError: false, pricelists: json, showOverview: true });
    } else {
      // load the customer specific page
      this.setState({ mode: "customer", customer: customer, connectionError: false, pricelists: json, showOverview: false });
    }
  }

  logout() {
    this.setState({ mode: "login", currentBon: null });
  }


  selectTechnician(evt) {
    // change the office for current user
    this.setState({ selectedUser: evt.target.value });
  }

  tokenExpired(oldToken) {
    this.setState({ mode: "relogin", oldToken: oldToken });
  }

  render() {

    var accessDenied = false;

    // do not allow access to the main view when there is no "office" defined
    if (this.state.mode === "main" && this.state.selectedUser === "") accessDenied = true;

    return (<React.Fragment>
      <div className="row header no-print">
        <div className="col" title={"Versie: " + this.state.version}><h3>Digibon  </h3></div>
        {this.state.isTest &&
          <div className="col bg-danger text-center"><h3>TEST OMGEVING</h3></div>
        }
        <div className="col text-end">
          {this.state.mode !== "login" &&

            <button className="btn btn-primary me-2" onClick={this.logout.bind(this)}>uitloggen</button>


          }
        </div>
      </div>

      <div className="p-lg-4 p-md-3 p-2">
        {
          !this.state.connectionError && this.state.mode === "loading" && <p className="text">
            Bezig met initializeren...
          </p>
        }
        {
          this.state.connectionError && <p className="text-danger">
            Er is een probleem met het ophalen van gegevens. Ververs de pagina of neem contact op met IT.
          </p>
        }
        {
          accessDenied && <p className="text-danger">
            Geen toegang tot dit deel van de applicatie
          </p>
        }
        {this.state.mode === "login" && !this.state.connectionError && <Login loginSuccess={this.loginSuccess.bind(this)} />
        }
        {this.state.mode === "relogin" && !this.state.connectionError &&
          <Login loginSuccess={this.reloginSuccess.bind(this)} relogin={true} />
        }
        {this.state.mode === "test" &&
          <React.Fragment>
            <h2>TEST</h2>
            <p>Response from DigibonService</p>
            <pre>{this.state.testResult}</pre>
          </React.Fragment>

        }
        {this.state.mode === "customer" &&
          <div>
            <h4>Historie voor {this.state.customer}</h4>
            <VisitHistory cardCode={this.state.customer}></VisitHistory>
          </div>
        }
        {!accessDenied && this.state.mode === "main" && <div id="selector">
          <div className="no-print" style={{ float: "right", marginRight: "10px" }}>

            {Config.Technicians && Config.Technicians.filter && Config.isEnableSelectTechnician(this.state.jwtToken) && <span>
              <select className="me-4" onChange={this.selectTechnician.bind(this)} value={this.state.selectedUser}>
                <option value={this.state.jwtToken.office}>{this.state.jwtToken.name}</option>
                {Config.Technicians.filter(p => p.value !== this.state.jwtToken.office).map((item, index) => <option key={index} value={item.code}>{item.name}</option>)}
              </select>
            </span>}

            {!Config.isEnableSelectTechnician(this.state.jwtToken) && <span className="me-4">
              {this.state.jwtToken.name} ({this.state.jwtToken.office})
            </span>}

            Vandaag: {this.state.currentTime.format('DD-MM-YYYY HH:mm')}
          </div>

          <Tabs activeTab="Overview" ref={this.tabsRef}>
            <div label="Overview">

              {this.state.showOverview &&
                <Overview SelectBon={this.SelectBon.bind(this)} selectedUser={this.state.selectedUser}
                  notifyTokenExpired={this.tokenExpired.bind(this)}
                  selectedDate={this.state.selectedDate}
                ></Overview>
              }
            </div>


            <div label="Datum" >
              <div>
                <Datum ChangeDate={this.ChangeDate.bind(this)} selectedDate={this.state.selectedDate} selectedUser={this.state.selectedUser} ></Datum>
              </div>
            </div>
            <div label="Voorraad" >
              <div>
                <Stock selectedUser={this.state.selectedUser}></Stock>
              </div>
            </div>
            <div label="Alarmcentrales" >
              <div>
                <EmergencyCenters></EmergencyCenters>
              </div>
            </div>

          </Tabs>
        </div>
        }
        {this.state.mode === "bon" && <div id="bon">
          <div>

            <ServiceCall current={this.state.currentBon} CloseBon={this.CloseBon.bind(this)}
              predefinedTexts={this.state.predefinedTexts}
              selectableProducts={this.selectableProducts}
              technicianCode={this.state.jwtToken.office}
              technicianName={this.state.jwtToken.name}
              emergencyCenters={this.state.emergencyCenters}
              deviceCodeLists={this.state.deviceCodeLists}
              selectedUser={this.state.selectedUser}
              isAdmin={Config.isAdmin(this.state.jwtToken)}
              ></ServiceCall>
          </div>
        </div>
        }
      </div>
      {this.state.mode === "login" && this.state.version &&
        <div className="version">Versie: {this.state.version}</div>
      }
    </React.Fragment>
    );
  }
}

export default DigibonMain;
